import util from '@bmp-vue/core/api/util'
const controller = 'RestricoesContratacao'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
    RealizarValidacaoInicial: function (documentoFederal, nome) {
        return util.Axios.Get(controller + `/${documentoFederal.replace(/[^0-9]/g, "")}/ValidacaoInicial?nome=${encodeURIComponent(nome)}`)
    },
    ValidarPermissaoCriacaoRepresentanteLegal: function (numeroControleIF) {
        return util.Axios.Get(controller + `/${numeroControleIF}/ValidacaoPermissaoAbertura`)
    }
})